// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Input for updating function alarm thresholds
 * @export
 * @interface AlarmMonitorSettings
 */
export interface AlarmMonitorSettings {
    /**
     * Critical high threshold
     */
    highHighLimit?: number;
    /**
     * Warning high threshold
     */
    highLimit?: number;
    /**
     * Warning low threshold
     */
    lowLimit?: number;
    /**
     * Critical low threshold
     */
    lowLowLimit?: number;
    /**
     * Indicates if the alarm monitor is active or not. If disabled, the thresholds are still active, but no alarm is triggered
     */
    enabledState?: boolean;
    /**
     * Time interval in seconds during which an alarm condition must remain continuously true before the alarm becomes active.
     */
    onDelay?: number;
    /**
     * Time interval in seconds during which the alarm condition must remain cleared before the alarm becomes inactive.
     */
    offDelay?: number;
}

/**
 * Check if a given object implements the AlarmMonitorSettings interface.
 */
export function instanceOfAlarmMonitorSettings(value: object): value is AlarmMonitorSettings {
    return true;
}

export function AlarmMonitorSettingsFromJSON(json: any): AlarmMonitorSettings {
    return AlarmMonitorSettingsFromJSONTyped(json, false);
}

export function AlarmMonitorSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlarmMonitorSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'highHighLimit': json['highHighLimit'] == null ? undefined : json['highHighLimit'],
        'highLimit': json['highLimit'] == null ? undefined : json['highLimit'],
        'lowLimit': json['lowLimit'] == null ? undefined : json['lowLimit'],
        'lowLowLimit': json['lowLowLimit'] == null ? undefined : json['lowLowLimit'],
        'enabledState': json['enabledState'] == null ? undefined : json['enabledState'],
        'onDelay': json['onDelay'] == null ? undefined : json['onDelay'],
        'offDelay': json['offDelay'] == null ? undefined : json['offDelay'],
    };
}

export function AlarmMonitorSettingsToJSON(json: any): AlarmMonitorSettings {
    return AlarmMonitorSettingsToJSONTyped(json, false);
}

export function AlarmMonitorSettingsToJSONTyped(value?: AlarmMonitorSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'highHighLimit': value['highHighLimit'],
        'highLimit': value['highLimit'],
        'lowLimit': value['lowLimit'],
        'lowLowLimit': value['lowLowLimit'],
        'enabledState': value['enabledState'],
        'onDelay': value['onDelay'],
        'offDelay': value['offDelay'],
    };
}

